import React from "react";
import VBRadio from "./vbRadio";

class VBRadioGroup extends React.Component {
  constructor(props) {
    super(props);
    // Update the component's state to set 'selectedOption' to the clicked value
    this.state = {
      selectedOption: props.initial,
    };
  }

  handleRadioButtonClick = (value) => {
    this.setState({ 
      selectedOption: value,
    });

    if (this.props.onChange) {
      // If an 'onChange' function is provided, call it with the selected 'value'
      this.props.onChange(value);
    }
  }

  render() {
    // Destructure the 'options' and 'selectedOption' properties from props and state
    const { options } = this.props;
    const { selectedOption } = this.state;

    return (
      <>
        {options.map((option) => (
          <VBRadio
            key={option.value}
            label={option.label}
            value={option.value}
            checked={selectedOption === option.value} 
            onClick={this.handleRadioButtonClick}
          />
        ))}
      </>
    );
  }
}

export default VBRadioGroup;